<template>
  <!-- 信用限额table -->
  <a-table
    v-if="show"
    :columns="creditLimitColumns"
    :data-source="dataSource"
    :pagination="false"
    bordered
    :scroll="SCROLL"
  >
    <!-- 自定义渲染表头的title行 -->
    <label
      v-for="titleItem in customTitleList"
      :key="titleItem.keyName"
      :for="`${TABLE_NAME}_${titleItem.keyName}`"
      :slot="`${titleItem.keyName}Title`"
      class="ant-form-item-required"
    >
      {{ titleItem.title }}
    </label>

    <span slot="type">信用限额</span>
    <span slot="amount" slot-scope="text">{{ text | formatAmount }}</span>
    <span slot="totalWithRoadAmount" slot-scope="text, record">
      <!-- {{
        loadTotalWithRoadAmount(record.amount, record.limitAmountFinal)
          | formatAmount
      }} -->
      {{ record.limitAmountFinal | formatAmount }}
    </span>
    <span slot="indateStart" slot-scope="text">{{ text }}</span>
    <span slot="indateEnd" slot-scope="text">至 {{ text }}</span>

    <template slot="limitConditionType" slot-scope="text, record">
      <span v-if="!record.limitConditionType">
        无
      </span>
      <span v-else>
        NET AR 超 {{ record.limitConditionAmount | formatAmount }} 元控货
      </span>
    </template>
    <!-- 货币 -->
    <template slot="moneyId" slot-scope="text, record">
      <span v-if="record.moneyId == 0">
        人民币
      </span>
      <span v-else>
        {{ record.moneyName }}
      </span>
    </template>
  </a-table>
</template>

<script>
import { CREDIT_TYPE_OBJ, CREDIT_TYPE_VALUE_OBJ } from '../../const'
import {
  TYPE_WIDTH,
  AMOUNT_WIDTH,
  TOTAL_AMOUNT_WIDTH,
  INDATE_WIDTH,
  TERM_WIDTH,
  INDATE_START_WIDTH,
  LIMIT_CONDITION_WIDTH,
  SCROLL,
} from './config'

const TABLE_NAME = 'creditLimitTable'
export default {
  name: 'CreditLimitTable',
  data() {
    return {
      TABLE_NAME,
      CREDIT_TYPE_VALUE_OBJ,
      SCROLL,
      creditLimitColumns: [
        {
          title: '信用类型',
          dataIndex: 'type',
          scopedSlots: { customRender: 'type' },
          width: TYPE_WIDTH,
        },
        {
          dataIndex: 'amount',
          slots: { title: 'amountTitle' },
          scopedSlots: { customRender: 'amount' },
          width: AMOUNT_WIDTH,
        },
        {
          dataIndex: 'moneyId',
          slots: { title: 'moneyIdTitle' },
          scopedSlots: { customRender: 'moneyId' },
          width: TERM_WIDTH,
        },
        {
          title: '申请后限额峰值(RMB元)',
          dataIndex: 'totalWithRoadAmount',
          scopedSlots: { customRender: 'totalWithRoadAmount' },
          width: TOTAL_AMOUNT_WIDTH,
        },
        {
          dataIndex: 'indateStart',
          slots: { title: 'indateStartTitle' },
          scopedSlots: { customRender: 'indateStart' },
          width: INDATE_START_WIDTH,
        },
        {
          dataIndex: 'indateEnd',
          slots: { title: 'indateEndTitle' },
          scopedSlots: { customRender: 'indateEnd' },
          width: INDATE_WIDTH,
        },
        {
          title: '账期(天)',
          dataIndex: 'term',
          width: TERM_WIDTH,
        },
        {
          dataIndex: 'limitConditionType',
          slots: { title: 'limitConditionTypeTitle' },
          scopedSlots: { customRender: 'limitConditionType' },
          width: LIMIT_CONDITION_WIDTH,
        },
      ],
      // 自定义表头中title
      customTitleList: [
        {
          title: '本次申请增加额度(元)',
          keyName: 'amount',
        },
        {
          title: '货币',
          keyName: 'moneyId',
        },
        {
          title: '额度生效日',
          keyName: 'indateStart',
        },
        {
          title: '额度有效期',
          keyName: 'indateEnd',
        },
        {
          title: '限额条件',
          keyName: 'limitConditionType',
        },
      ],
    }
  },
  props: ['type', 'dataSource', 'baseInfo'],
  computed: {
    show() {
      const type = this.type
      return (
        type == CREDIT_TYPE_VALUE_OBJ.CREDIT_TYPE ||
        type == CREDIT_TYPE_VALUE_OBJ.CREDIT_NORMAL_TYPE ||
        type == CREDIT_TYPE_VALUE_OBJ.CREDIT_TEMPORARY_TYPE ||
        type == CREDIT_TYPE_VALUE_OBJ.CREDIT_SPECIAL_TYPE
      )
    },
    typeText() {
      return CREDIT_TYPE_OBJ[CREDIT_TYPE_VALUE_OBJ.CREDIT_TYPE]
    },
  },

  methods: {
    loadTotalWithRoadAmount(num, limitAmountFinal) {
      const baseInfo = this.baseInfo
      if (baseInfo) {
        console.log(baseInfo)
        const running = baseInfo.running
        if (running == 1) {
          const totalCreditLimitWithRoad =
            this.baseInfo.totalCreditLimitWithRoad || 0
          const amount = num || 0
          return parseFloat(amount) + parseFloat(totalCreditLimitWithRoad)
        }
        return limitAmountFinal
      }
      return 0
    },
  },
}
</script>

<style></style>
